export default class CodeLength {}
CodeLength.TwoFA = 6;
CodeLength.EmailVerification = 6;
CodeLength.ResetPassword = 6;
CodeLength.Passwordless = 7;
